import { useThemeMode } from '@/hooks/useThemeMode'
import s from './ThemeSwitch.module.css'

const ThemeSwitch = () => {
  const { isDarkTheme, toggleTheme } = useThemeMode()

  return (
    <button
      type="button"
      className={s.switch}
      aria-pressed={isDarkTheme}
      aria-label={isDarkTheme ? 'Включить светлую тему' : 'Включить темную тему'}
      data-hover-title={isDarkTheme ? 'Светлая тема' : 'Темная тема'}
      onClick={toggleTheme}
    >
      <span className={s.icon}>{isDarkTheme ? '☾' : '☀'}</span>
      <span className={s.thumb} />
    </button>
  )
}

export default ThemeSwitch
